import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  errorMessage: {
    key: 'ZaiIframeProvider-errorMessage',
    defaultValue: 'Oops, a ZAI não carregou corretamente.',
  },
})
